export const Container = {
    MuiContainer: {
        defaultProps: {
            maxWidth: false,
            disableGutters: true
        }
    }
};

//# sourceMappingURL=Container.js.map